<template>
  <alzata-dialog
    ref="modal"
    size="lg"
    :title="'Delete Task Item'"
    seamless
  >
    <div class="row mt-n4">
      <div class="col-12">
        <span for="name" class="small">Do you want delete "{{name}}"?</span>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide();">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="deleteTaskItem">
        Delete
      </button>
    </template>
  </alzata-dialog>
</template>

<script>

export default {
  name: "DeleteTaskItemDialog",
  emits: ["deleteTaskItem"],
  components: {
  },
  mounted() {
    (async () => {
     
    })();
  },
  data() {
    return {
      taskItem: null,
      name: null,
    };
  },
  methods: {
    show(taskItem) {
      (async () => {
        this.taskItem = taskItem;
        this.name = taskItem.title;

        this.$refs.modal.show();
      })();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async deleteTaskItem() {
      this.$emit("deleteTaskItem", this.taskItem);
    },
  },
};
</script>
